class Describe {
    /**
     * 构造描述对象
     * @param {string} name - 组件名称
     * @param {string} componentID - 组件ID,使用灵犀中对应模块的唯一标识
     */
    constructor(name, componentID) {
        this.name = name;
        this.componentID = componentID;
        // 用于描述页面结构信息
        this.structure = [];
        // 用于描述子组件
        this.subComponent = {};
    }
    getPageStructure() {
        let res = this.componentID;
        this.structure.forEach((component) => {
            res += `-${component.getPageStructure()}`;
        });
        return res;
    }
    getComponentID() {
        return this.componentID;
    }
    setSubComponent(name, describe) {
        this.subComponent[name] = describe;
    }
    getSubComponent(name) {
        return this.subComponent[name];
    }
}

export default Describe;
